"use client";

import React from "react";
import { DEMO_CALENDAR_LINK } from "@/lib/constants/booking";
import { UnifiedModal } from "./UnifiedModal";

interface BookADemoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Canonical "Book a Demo" modal. Wraps UnifiedModal's cal flow with the shared title,
 * subtitle, and calendar link so the demo copy lives in one place instead of being
 * duplicated across every landing/marketing surface that offers a demo CTA.
 *
 * @param props - Open state and close handler from the caller's modal manager.
 * @returns The demo modal.
 */
export const BookADemoModal: React.FC<BookADemoModalProps> = ({ isOpen, onClose }) => (
  <UnifiedModal
    type="cal"
    isOpen={isOpen}
    onClose={onClose}
    title="Book a Demo"
    subtitle="Schedule a 30-minute demo with our team"
    calLink={DEMO_CALENDAR_LINK}
  />
);
